import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SurveyResponse } from '@nx-c4g/c4g-models';
import { BaseSurveyStepComponent } from '../base-survey-step/base-survey-step.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'c4g-text-input-survey-step',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './text-input-survey-step.component.html',
  styleUrls: ['./text-input-survey-step.component.scss']
})
export class TextInputSurveyStepComponent extends BaseSurveyStepComponent implements OnInit, AfterViewInit {
  feedback = '';
  currentYear = new Date().getFullYear();

  @ViewChild('inputEl') inputEl?: ElementRef<HTMLInputElement>;
  @ViewChild('textareaEl') textareaEl?: ElementRef<HTMLTextAreaElement>;

  constructor(
    @Inject('stepData') stepData: any,
    @Inject('stepResponse') stepResponse: any,
    @Inject('initialStepResponse') initialStepResponse: any,
    private translate: TranslateService
  ) {
    super(stepData, stepResponse, initialStepResponse);
  }

  override ngOnInit() {
    super.ngOnInit();
    if (this.initialStepResponse && this.initialStepResponse.response?.[0]?.values?.[0]) {
      this.feedback = this.initialStepResponse.response[0].values[0];
    }
  }

  ngAfterViewInit(): void {
    // Focus the correct element after view init
    setTimeout(() => {
      if (this.isMultiline && this.textareaEl) {
        this.textareaEl.nativeElement.focus();
      } else if (!this.isMultiline && this.inputEl) {
        this.inputEl.nativeElement.focus();
      }
    });
  }

  override async getResponse(): Promise<SurveyResponse | undefined> {
    if (!this.stepData) return undefined;
    const response = {
      stepId: this.stepData._id,
      showValueInReport: true,
      response: [
        {
          _id: this.stepData.options[0]?._id || '',
          values: [this.feedback]
        }
      ]
    };
    console.log('response', response);
    return response;
  }

  get inputType(): string {
    // Default to 'text' if not specified or not recognized
    const type = this.stepData?.options[0]?.inputType;
    if (!type) return 'text';
    if (type === 'number' || type === 'email' || type === 'phone' || type === 'text') return type === 'phone' ? 'tel' : type;
    if (type === 'year') return 'number';
    return 'text';
  }

  get isMultiline(): boolean {
    return this.stepData?.options[0]?.inputType === 'multiline';
  }

  getLangValue(mls: { en: string; fr: string }): string {
    const lang = this.translate.currentLang === 'fr' ? 'fr' : 'en';
    return mls?.[lang] || mls?.['en'] || '';
  }

  override isValid(): boolean {
    const value = this.feedback?.trim();
    const inputType = this.stepData?.options[0]?.inputType || 'text';
    if (!value) return false;
    switch (inputType) {
      case 'number':
        return /^\d+$/.test(value);
      case 'email':
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
      case 'phone':
        return /^[0-9\-+()\s]+$/.test(value);
      case 'year': {
        const year = Number(value);
        return /^\d{4}$/.test(value) && year >= 1900 && year <= this.currentYear;
      }
      default:
        return value.length >= 3;
    }
  }
}

